import React, { useState } from "react";
import DefaultView from "../../layouts/content/DefaultView/DefaultView";
import * as ThemeManager from "../../logic/ThemeManager";
//import * as LocaleManager from "../../logic/LocaleManager";
import { getTranslation as translate } from "logic/LocaleManager";
import parse from 'html-react-parser';
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import GoogleLogin from "../../components/GoogleLogin";
import MicrosoftLogin from "../../components/MicrosoftLogin";
import { googleClientId, googleProviderId, microsoftClientId, microsoftProviderId } from "../../GlobalConstants";

// Externals
import cn from "classnames";

//Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appSettingsActions from "redux/actions/appSettingsActions";

// DevExtreme components
import notify from 'devextreme/ui/notify';
import { SelectBox, Button } from 'devextreme-react';
import { RadioGroup } from 'devextreme-react';

// Component styles
import classes from "./SettingsPage.module.scss";

function SettingsPage(props) {
  const { theme, taskLayout, configDataAuthToken } = props;

  const [selectedTheme, setSelectedTheme] = useState(theme);
  const [selectedLayout, setSelectedLayout] = useState(taskLayout);
  //const [selectedLocale, setSelectedLocale] = useState(locale);

  const themeDescription = "Select your prefered theme.<br/>Note that in order to switch theme the browser must be reloaded!<br/>"
  const layoutDescription = "Select your prefered task layout.<br/>You can choose between 'classic' and 'experimental'!.<br />";
  //const languageDescription = "Select your prefered language.<br/>";
  const userAccountDescription = "Link your BOS User account with an external provider account!<br/>";

  function getAvailableLayouts() {
    return ["classic", "experimental"];
  }

  const onThemeValueChanged = (args) => {
    setSelectedTheme(args.value);
  }

  const onLayoutValueChanged = (args) => {
    setSelectedLayout(args.value);
  }

  // const onLocaleValueChanged = (args) => {
  //   setSelectedLocale(args.value);
  // }

  const onThemeButtonClick = (args) => {
    props.appSettingsActions.setTheme(selectedTheme);
    ThemeManager.applyCurrentTheme();
  }

  const onLayoutButtonClick = (args) => {
    props.appSettingsActions.setTaskLayout(selectedLayout);
  }

  // const onLocaleButtonClick = (args) => {
  //   debugger;
  //   props.appSettingsActions.setLocale(selectedLocale);
  // }

  async function loginWithProvider(type, token) {
    await linkUsers(type, token);
  }

  function loginWithProviderError(error) {
    notify(error, "error");
  }

  async function linkUsers(providerId, token) {
    try {
      let error = await BosIdentityServices.fetchLinkUsers(configDataAuthToken, providerId, token);
      if (error) throw new Error(error);
      notify(translate("settingsPage.userAccount.linkSuccessMessage", "Linked successfully!"), "success");
    } catch (error) {
      console.error(error);
      notify(error, "error");
    }
  }

  return (
    <DefaultView>
      <div className={cn(classes.title, "ui-default-headline")}>{translate("general.settings", "Settings")}</div>

      <div className={cn(classes.settingsContainer, "dx-card")}>
        <div className={cn(classes.subTitle, "ui-default-headline-small")}>{translate("settingsPage.theme.title", "Switch theme here")}</div>
        <div>
          {parse(translate("settingsPage.theme.desc", themeDescription))}
        </div>
        <SelectBox
          width={200}
          value={selectedTheme}
          displayExpr="text"
          valueExpr="id"
          dataSource={ThemeManager.getAvailableThemes()}
          onValueChanged={onThemeValueChanged}
        />
        <Button
          text={translate("settingsPage.applyButton", "Apply")}
          onClick={onThemeButtonClick}
        />
      </div>

      <div className={cn(classes.settingsContainer, "dx-card")}>
        <div className={cn(classes.subTitle, "ui-default-headline-small")}>{translate("settingsPage.layout.title", "Switch your prefered task layout")}</div>
        <div>
          {parse(translate("settingsPage.layout.desc", layoutDescription))}
        </div>
        <RadioGroup
          items={getAvailableLayouts()}
          value={selectedLayout}
          layout="horizontal"
          onValueChanged={onLayoutValueChanged}
        />
        <Button
          text={translate("settingsPage.applyButton", "Apply")}
          onClick={onLayoutButtonClick}
        />
      </div>

      {/* <div className={cn(classes.settingsContainer, "dx-card")}>
        <div className={cn(classes.subTitle, "ui-default-headline-small")}>{translate("settingsPage.language.title", "Switch language here")}</div>
        <div>
          {parse(translate("settingsPage.language.desc", languageDescription))}
        </div>
        <SelectBox
          width={200}
          value={selectedLocale}
          displayExpr="desc"
          valueExpr="id"
          dataSource={LocaleManager.getAvailableLocales()}
          onValueChanged={onLocaleValueChanged}
        />
        <Button
          text={translate("settingsPage.applyButton", "Apply")}
          onClick={onLocaleButtonClick}
        />
      </div> */}

      <div className={cn(classes.settingsContainer, "dx-card")}>
        <div className={cn(classes.subTitle, "ui-default-headline-small")}>{translate("settingsPage.userAccount.title", "Link user account")}</div>
        <div>
          {parse(translate("settingsPage.userAccount.desc", userAccountDescription))}
        </div>

        <div className={classes.externalProviders}>
          <div className={classes.altLoginContent}>
            <GoogleLogin clientId={googleClientId} buttonText="Mit Google verknüpfen" onSuccess={(token) => loginWithProvider(googleProviderId, token)} onFailure={(args) => loginWithProviderError(args)} />
          </div>
          <div className={classes.altLoginContent}>
            <MicrosoftLogin clientId={microsoftClientId} buttonText="Mit Micorosoft verknüpfen" onSuccess={(token) => loginWithProvider(microsoftProviderId, token)} onFailure={(args) => loginWithProviderError(args)} />
          </div>
        </div>
      </div>

    </DefaultView>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    //locale: state.appSettings.locale,
    theme: state.appSettings.theme,
    taskLayout: state.appSettings.taskLayout,
    configDataAuthToken: state.dataSegments.configDataSegment.authToken,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appSettingsActions: bindActionCreators(appSettingsActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsPage);
